module.exports = __webpack_public_path__ + "img/work-at-han.f9d43bfe.png";